// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"644":"react","874":"antd"}[chunkId] || chunkId) + "." + {"354":"e0234a8ebebe1653c31f","432":"63072a6545288c84e9c1","623":"29c1503238a4bfb38ece","644":"b9721780c684243d7760","874":"63108cdec820b06d5976"}[chunkId] + ".chunk.js";
};